import styled from "styled-components";
import {
	ColorPaletteOptions,
	ColorPaletteSemanticOptions,
} from "../../../../types/theming";
import BadgeBase from "../BadgeBase/BadgeBase";
import {
	SemanticBadgeVariantOptions,
	StyledSemanticBadgeProps,
} from "./SemanticBadge.types";

const getIconColor = (
	variant: SemanticBadgeVariantOptions
): ColorPaletteSemanticOptions => {
	switch (variant) {
		case "error":
			return "semantic_error_600";
		case "warning":
			return "semantic_warning_400";
		default:
			return "semantic_success_500";
	}
};

const StyledSemanticBadge = styled(
	({ variant, ...props }: StyledSemanticBadgeProps) => (
		<BadgeBase
			backgroundColor={`semantic_${variant}_100` as ColorPaletteOptions}
			color={`semantic_${variant}_700` as ColorPaletteOptions}
			icon={variant === "warning" ? "alert" : variant}
			iconColor={getIconColor(variant)}
			{...props}
		/>
	)
)<StyledSemanticBadgeProps>``;

export default StyledSemanticBadge;
